// Same green and red as the "kvart €/m2" column (CoreUI text-success /
// text-danger: #2eb85c and #e55353).
export const priceColorGreen = "#2eb85c";
export const priceColorRed = "#e55353";
export const priceGreenUntil = 200000;
export const priceRedFrom = 500000;

const green = { h: 140, s: 60, l: 45 }; // #2eb85c
const red = { h: 0, s: 74, l: 61 }; // #e55353

const lerp = (from, to, t) => from + (to - from) * t;

const hslToHex = (h, s, l) => {
  const saturation = s / 100;
  const lightness = l / 100;
  const a = saturation * Math.min(lightness, 1 - lightness);
  const channel = (n) => {
    const k = (n + h / 30) % 12;
    const value = lightness - a * Math.max(-1, Math.min(k - 3, 9 - k, 1));
    return Math.round(value * 255).toString(16).padStart(2, "0");
  };
  return `#${channel(0)}${channel(8)}${channel(4)}`;
};

// Price in EUR -> CSS colour, or null for a missing/zero price.
// <= 200.000 green, >= 500.000 red, in between the hue moves from green
// through yellow/orange to red. Lightness dips a little in the middle so the
// yellow shades stay readable on the white/striped table rows.
export const getPriceColor = (price) => {
  const value = typeof price === "string" ? parseFloat(price) : price;
  if (typeof value !== "number" || !Number.isFinite(value) || value <= 0) {
    return null;
  }
  if (value <= priceGreenUntil) {
    return priceColorGreen;
  }
  if (value >= priceRedFrom) {
    return priceColorRed;
  }
  const t = (value - priceGreenUntil) / (priceRedFrom - priceGreenUntil);
  const lightness = lerp(green.l, red.l, t) - 12 * Math.sin(Math.PI * t);
  return hslToHex(lerp(green.h, red.h, t), lerp(green.s, red.s, t), lightness);
};
